/**
 * Product resource types from the backend ledger API.
 * These values match the backend's ResourceType enum.
 * @see openapi-spec/customer-bff/ledger/common/components.yaml ProductType
 */
export const PRODUCT_TYPE = {
  CURRENCIES: "currencies",
  DIGITAL_ASSETS: "digital-assets",
} as const;

/**
 * Type representing the product type values.
 * Use this type instead of inline `"currencies" | "digital-assets"` throughout the codebase.
 */
export type ProductType = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE];

/**
 * Type guard for ProductType
 */
export function isProductType(value: string): value is ProductType {
  return (
    value === PRODUCT_TYPE.CURRENCIES || value === PRODUCT_TYPE.DIGITAL_ASSETS
  );
}
